import { Box, Grid, Stack } from "@mui/material";
import MiniCalendarWidget from "./components/MiniCalendarWidget";
import WeatherWidget from "./components/WeatherWidget";
import ScheduleWidget from "./components/ScheduleWidget";
import VenuesWidget from "./components/VenuesWidget";
import SocialMediaWidget from "./components/SocialMediaWidget";
import MemoryBooksWidget from "./components/MemoryBookWidget";
import ServiceQuoteForm from "../proposal/service-quote-form/ServiceQuoteForm";
import { useState } from "react";

const Sales = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());

  return (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 3 }}>
          <Stack spacing={3}>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                gap: 2,
              }}
            >
              <Box sx={{ aspectRatio: "1 / 1" }}>
                <MiniCalendarWidget
                  selectedDate={selectedDate}
                  onDateSelect={setSelectedDate}
                />
              </Box>

              <Box sx={{ aspectRatio: "1 / 1" }}>
                <WeatherWidget />
              </Box>
            </Box>

            <ScheduleWidget selectedDate={selectedDate} crewMemberId={23} />
          </Stack>
        </Grid>

        <Grid size={{ xs: 12, md: 9 }}>
          <Stack spacing={3}>
            <ServiceQuoteForm />

            <Grid container spacing={3} sx={{ flexGrow: 1 }}>
              <Grid size={{ xs: 12, md: 4 }}>
                <VenuesWidget />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <SocialMediaWidget />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <MemoryBooksWidget />
              </Grid>
            </Grid>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Sales;
